import { ResumePraticaRequest } from "@api/client";
import { praticaRiprendi } from "common/_redux/pratica/actions";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { errorHandler } from "core/store/config";
import { useAppDispatch } from "core/store/hooks";
import { OnboardingSteps } from "pages/onBoarding/config";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const routeEscluse = [
	AppRouterService.get(PathEnum.anagraficaLR),
	AppRouterService.get(PathEnum.ulterioriInformazioniLR),
	AppRouterService.get(PathEnum.completeLR),
	AppRouterService.get(PathEnum.anagraficaTE),
	AppRouterService.get(PathEnum.ulterioriInformazioniTE),
	AppRouterService.get(PathEnum.verificaIdentitaTE),
	AppRouterService.get(PathEnum.completeTE),
];

const RipresaPraticaWebhook: React.FC = () => {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const resumePratica = () => {
		let data = searchParams.get("data");

		if (data) {
			let request: ResumePraticaRequest = {
				data,
			};

			dispatch(praticaRiprendi(request))
				.unwrap()
				.then(async (res) => {
					if (res) {
						navigate("/", { replace: true });

						// if (res.idCliente && res.idPratica) {
						// 	await dispatch(subjectGetDetails());
						// }

						if (res.statoPratica === "REOPENED") {
							navigate(AppRouterService.get(PathEnum.reopen));
							window.location.reload();

							return;
						}

						if (res?.stepStatus) {
							const stepStatus = res?.stepStatus;

							const stepRef = OnboardingSteps?.find((step) => {
								if (step?.backendEnumRef == stepStatus) {
									return step;
								}

								return step?.subSteps?.find((subStep) => subStep?.backendEnumRef == stepStatus);
							});
							const stepRefIndex = OnboardingSteps?.findIndex((s) => s?.route == stepRef?.route);

							const substepRef = stepRef?.subSteps?.find(
								(subStep) => subStep?.backendEnumRef == stepStatus
							);
							const substepRefIndex =
								stepRef?.subSteps?.findIndex((ss) => ss?.route == substepRef?.route) || 0;

							OnboardingSteps?.forEach((s, index) => {
								if (index < stepRefIndex) {
									s?.subSteps?.forEach((ss, i) => {
										if (ss?.route) {
											if (routeEscluse?.includes(ss?.route)) return;

											return navigate(ss?.route);
										}
									});
								} else if (index == stepRefIndex) {
									if (substepRef) {
										s?.subSteps?.forEach((ss, i) => {
											if (ss?.route && i <= substepRefIndex) {
												if (routeEscluse?.includes(ss?.route)) return;

												return navigate(ss?.route);
											}
										});
									} else {
										return navigate(s?.route);
									}
								}
							});

							window.location.reload();
						}
					}
				});
		} else {
			errorHandler("Pratica not found", dispatch, true);
		}
	};

	useEffect(() => {
		resumePratica();
	}, []);

	return null;
};

export default RipresaPraticaWebhook;
